import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  /**
   * General health forms
   */
  {
    // 1
    label: 'What gender do you identify as?',
    subLabel: '(Select one)',
    field: 'genGender',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'woman',
          value: 'Cisgender woman\n(born and identify as a woman)'
        },
        {
          key: 'man',
          value: 'Cisgender man\n(born and identify as a man)'
        },
        {
          key: 'transgender',
          value:
            'Transgender (identify as a gender other than the one assigned at birth)'
        },
        {
          key: 'nonbinary',
          value:
            'Nonbinary\n(identify as a gender outside of the gender binary)'
        },
        {
          key: 'otherGender',
          value: 'Other',
          answer: {
            type: 'text',
            name: 'otherGenderDesc',
            placeholder: 'Please specify'
          }
        },
        { key: 'notToSayGender', value: 'Prefer not to say' }
      ]
    }
  },
  {
    // 2
    label: 'What pronouns do you prefer?',
    subLabel: '(Select one)',
    field: 'genPronoun',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'she', value: 'She/her/hers' },
        { key: 'he', value: 'He/him/his' },
        { key: 'they', value: 'They/them/their' },
        {
          key: 'otherPronoun',
          value: 'Other',
          answer: {
            type: 'text',
            name: 'otherPronounDesc',
            placeholder: 'Please specify'
          }
        },
        { key: 'notToSayPronoun', value: 'Prefer not to say' }
      ]
    }
  },
  {
    // 3
    label: 'Which of the following best describes you?',
    subLabel: '(Select at least one, or all that apply)',
    field: 'genRace',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'white', value: 'White' },
        { key: 'hispanic', value: 'Hispanic or Latino' },
        { key: 'black', value: 'Black' },
        { key: 'southeastAsian', value: 'Southeast Asian' },
        { key: 'middleEastern', value: 'Middle Eastern' },
        { key: 'nativeAmerican', value: 'Indigenous' },
        {
          key: 'otherRace',
          value: 'A race/ethnicity not listed here',
          answer: {
            type: 'text',
            name: 'otherRaceDesc',
            placeholder: 'Please specify'
          }
        }
      ]
    }
  },
  {
    // Lab work check
    label: 'Have you done your blood work?',
    field: 'didBloodWork',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes',
          answer: {
            type: 'list',
            items: [
              {
                type: 'single_select',
                options: [
                  { key: 'haveResult', value: 'I have my blood result' },
                  { key: 'dontHaveResult', value: 'I do not have my blood result' }
                ]
              }
            ]
          }
        },
        {
          key: 'no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:'If you have received your lab result from the lab, you can upload it here.',
    subLabel: 'Please upload your lab test results (e.g. jpg/png/pdf):',
    field: 'labResultUpload',
    type: 'file_upload',
    answer: [
      {
        resourceId: 'labResults',
        buttonLabel: 'Upload Results'
      }
    ]
  }
];

export default questionsModels;
